import { peekPendingQrDraft } from './qrEncode';
import { peekSignatureBuilderIntent } from '../tools/signature-builder/pendingIntent';

const STAFF_ROLES = ['staff', 'admin', 'super_admin'];

// Staff/admin land in the retail admin shell as before; a plain "user"
// account (customer, or anyone who registered just for the free tools)
// belongs in their own portal, never inside /admin/*.
export const destinationFor = (role, hasDraft, hasSignatureIntent) => {
  const isStaff = STAFF_ROLES.includes(role);
  if (hasDraft) return isStaff ? '/admin/qr-builder/new' : '/account/qr-codes/new';
  if (hasSignatureIntent) return '/account/signatures/new';
  return isStaff ? '/admin/cart' : '/account';
};

/** Where to send someone who just signed in, honouring any pending QR/signature work. */
export const loginDestination = (role) =>
  destinationFor(role, !!peekPendingQrDraft(), peekSignatureBuilderIntent());

// New registrations are always a plain "user" account - their QR Builder (and
// every other free tool) lives in their own portal, never under /admin.
export const postRegisterDestination = () =>
  peekPendingQrDraft() ? '/account/qr-codes/new' : (peekSignatureBuilderIntent() ? '/account/signatures/new' : '/shop');
